const masqKey = 'masq_account_id';

export const getMasqId = (url: string) => {
  const u = new URL(suitableUrl(url));
  return u.searchParams.get(masqKey);
};

const suitableUrl = (url: string) => (url.startsWith('http') ? url : `http://localhost${url}`);
